export default __webpack_public_path__ + "static/media/guide.65f01c65.svg";